export interface EyebrowProps {
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

export function Eyebrow({ children, className, style }: EyebrowProps) {
	return (
		<p
			className={className}
			style={{
				fontFamily: "var(--font-mono)",
				fontSize: 11,
				fontWeight: 600,
				letterSpacing: "0.18em",
				textTransform: "uppercase",
				color: "var(--color-dashboard-muted)",
				margin: 0,
				...style,
			}}
		>
			{children}
		</p>
	);
}
